import { Component, OnInit,Input, OnDestroy } from '@angular/core';
import { Injectable,ViewChild } from '@angular/core';
import { BackendService } from 'app/shared/backend.service';
import CONFIG from 'config';
import { AccountactivityService } from './accountactivity.service';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { MultiColumnGridService } from 'app/shared/multi-column-grid.service';
import { AuthService } from 'app/shared/auth.service';
import { NotificationService } from 'app/notification/notification.service';
import { SearchService } from 'app/shared/search.service';
import { OrderByService } from 'app/shared/orderby.service';
import { PaginationService } from 'app/shared/pagination.service';
import { CurrencyPipe,Location, DatePipe } from '@angular/common';
import { FilterService } from 'app/shared/filter.service';
import { Subject, Subscription } from 'rxjs';
import { Angular5Csv } from 'angular5-csv/dist/Angular5-csv';
import { MatInput } from '@angular/material/input';


@Component({
  selector: 'app-accountactivity',
  templateUrl: './accountactivity.component.html',
  styleUrls: ['./accountactivity.component.scss']
  
})
@Injectable()
export class AccountactivityComponent  implements OnInit
{
  @Input()
  openAccount:boolean;
  //apiUrl:string;
  result:string;
  currentSAccount;
  filtersOpen: boolean = false;
  DateFilter: FormGroup;
  datefilteroriginalitems: any;
  selectedCurrency: string = '';
 


//Raghava added

currency:any;
    exportDataOrder:any;
    currentPage: string = '';
    loadingData: boolean = false;
    pagenlenth: boolean = true;
    items: Object[] = [];
    originalItems: Object[] = [];
    filteredBySettlementAccount: Object[] = [];
    filteredByCurrency: Object[] = [];
    filteredBySAandC: Object[] = [];
    audit: Object[] = [];
    searchFilteredItems: Object[] = [];
    exportItems: Object[] = [];
    prefilteredItems: Object[] = []; //dropdown/checkbox filtered
    totalEntries: number = 0;
    dataCallback: Function;
    filterApplied: boolean = false;
    FilterByStatus: FormGroup;
    statusSubscription: Subscription;
    settlementAccount: FormGroup;
    accountNo: FormControl;
    TextSearch: FormGroup;
    term: FormControl;
    allSubscription: Subscription;
    selected;
    active: string = '';
    entryRange: Array<number>;
    entryRangeSubscription: Subscription;
    apiUrl: string = '';
    searchArray: Array<string> = [];
    accountsArray: Array<string> = [];
    securityArray: Array<string> = [];
    submitted: boolean = false;
    fields: string[] = [];
    fieldNames: string[] = [];
    defaultSortOrder: string = '';
    currentSortOrder: string = '';
    exportTitle: string = 'Exported-Data';
    // audit: any;
    checkbox: any;
    
    exchangerate: any;
    consolidate:any;
    echangereatecalculated:any;
    accuredintrest: any;
    repocurrency: any;
    accuredintrestcalculated: any;
    noEntrys: boolean = false;
    sortingpageload:any;

    datefilteredaudit: Object[] = [];
    RadioSearch: FormGroup;
    RadioFilter: FormControl;



  export:any;


  @ViewChild('fromInput', {
    read: MatInput
  }) fromInput: MatInput;
  
  @ViewChild('toInput', {
    read: MatInput
  }) toInput: MatInput;
  constructor( public location: Location,
    public backendService: BackendService,
    public authService: AuthService,
    //public accountService: AccountService,
    public notificationService: NotificationService,
    public formBuilder: FormBuilder,
    public searchService: SearchService,
    public orderByService: OrderByService,
    public router: Router,
    public paginationService: PaginationService,
    public filterService: FilterService,
   // public numberPipe: DecimalPipe,
    public currencyPipe: CurrencyPipe,
    public datePipe:DatePipe
             

              ) 
  { 
   
  }

  ngOnInit() 
  {
    this.currentPage="actitvity";
    this.accountNumber(this.authService.OperatingAcc);
    this.searchArray = ['accountNumber','currency', 'postingDate', 'sdate','securityDescription', 'settlementAmount','settlementDate','transactionType'];
    this.fieldNames = ['AccountNumber','SettlementDate', 'TransactionType','SecurityDescription','SettlementAmount',  'Currency'];
    this.defaultSortOrder = '';

    this.DateFilter = this.formBuilder.group({
      'startdate': [''],
      'enddate': ['']
  });

  this.term = new FormControl();
  this.TextSearch = new FormGroup({
      term: this.term,
    
  });
  this.accountNo = new FormControl();
  this.settlementAccount = new FormGroup({
      accountNo: this.accountNo
  });

  }

   accountNumber(value)
  {
    //console.log(value);
    this.apiUrl=CONFIG.getAccountInfo+"/"+value;
    //this.serviceInit(this.formatDataForSearch);

    this.getData();
  }

 

  getData() {
    this.sortingpageload="pageload";
 //   console.log('getdata');
    //if we have a text search enabled and delete an item, the grid won't filter properly, so reset search first
    this.clearSearch();
    // console.log("available " + this.authService.CustomerID);
//console.log(this.apiUrl);
    this.backendService.getData(`${this.apiUrl}/${btoa(this.authService.CustomerID)}`)
        .subscribe(data => {
            if (data['myCustomer'] != null) {
               
               
                this.originalItems = data['myCustomer'];
                this.exportDataOrder=data['myCustomer'];
                //this.currency=data['currency'];
                //console.log(data['currency']);
                //console.log(this.originalItems );
                //console.log(this.currency);

            }
           
            if (this.dataCallback) {
                this.dataCallback(this.originalItems);
            }

           this.searchFilteredItems = this.originalItems;

            //full list for pagination, and list for each page
            this.audit = this.originalItems;

            this.setGrid(1, this.totalEntries, "Getdata");
            this.orderBy(this.defaultSortOrder);
            this.paginationGrid();

            this.totalEntries = this.audit.length;
            if (this.audit.length === 0) {
                this.noEntrys = true;
            }
            // this.setGrid(1, this.totalEntries, "Getdata");
            // this.orderBy(this.defaultSortOrder);
            this.loadingDataStatus(true);
        },
       );
}
private loadingDataChangeConfirmedSource = new Subject<string>();

// Observable string streams
loadingDataChange$ = this.loadingDataChangeConfirmedSource.asObservable();
loadingDataStatus(loadingData: boolean) {

   // console.log(loadingData);
   if (!this.loadingData) {
       this.loadingData = loadingData;
       this.loadingDataChangeConfirmedSource.next('loadingData');
   } else {
       return;
   }
}

setGrid(start: number, length?: number, value?: string) {
    //console.log(length);
    const sentLen = length;
    this.pagenlenth = false;
    this.paginationService.setGrid(start, sentLen);
  }
orderBy(param){
  //console.log("Test")
    let itemsToOrder = this.originalItems;
   //// console.log(itemsToOrder);
    const altParam = param === this.defaultSortOrder ? undefined : this.defaultSortOrder;
    // if(this.filterApplied && !this.term.value) {
    //     itemsToOrder = this.prefilteredItems;
    // } else if(this.term.value) {
    //     itemsToOrder = this.searchFilteredItems;
    // }
    this.items = this.orderByService.orderByParam(param, itemsToOrder, altParam);
   //// console.log(this.items);
    this.setGrid(1, itemsToOrder.length);
  }
  paginationGrid() {
//console.log(this.originalItems.length)
    this.entryRangeSubscription = this.paginationService.entryRange.subscribe(range => {
    this.entryRange = range;
    this.audit = this.originalItems.slice(this.entryRange[0], this.entryRange[1]);
    ////console.log(this.audit);
    this.totalEntries = this.audit.length;
    ////console.log(this. totalEntries );
    ////console.log(this. audit );

  });
}


clearSearch() {
    //  this.term.setValue('');
    this.audit = this.originalItems;
    this.searchFilteredItems = [];
}
  exportDataOptions(submittedData?: Object[]) 
  {
    let name = 'Account Activity';
    let heading = 'Activity Activity CSV';
    // const data = submittedData || this.originalItems;
    // this.exportData(data, name, heading);
    //console.log(this.originalItems)
    this.export = JSON.parse(JSON.stringify(this.originalItems));
    this.export.forEach((value, index
        )=>{
        
        delete this.export[index]['sdate'];
        delete this.export[index]['postingDate'];
        
       
       
    });
    this.exportData(this.export, name, heading);
  }

  exportData(submittedData?: Object[], name?: string, heading?: string) 
  {

      var options = {
          fieldSeparator: ',',
          quoteStrings: '"',
          decimalseparator: '.',
          showLabels: true,
          showTitle: true,
          title: heading,
          useBom: true,
          //noDownload: true,
          headers: this.fieldNames,
          nullToEmptyString: true,
      };
      
      const data = submittedData;
      //console.log(data);
      new Angular5Csv(data, name, options);

  }

  SearchOpen() {
    if (this.filtersOpen == false) {
        this.filtersOpen = true;
        this.clearDateFilter();
    }
    else {
        this.filtersOpen = false;
        this.clearDateFilter();
    }
}
dateFilter(edate, sdate) 
    {

        //let startdate = this.datePipe.transform(sdate, "dd/MM/yyyy");
        //let enddate = this.datePipe.transform(edate, "dd/MM/yyyy");
        //console.log(edate,sdate)
        this.datefilteroriginalitems = this.originalItems;
        let startInclude: any = '';
        let endInclude: any = '';

        startInclude = new Date(sdate);
        endInclude = new Date(edate);
        let submit = {
            'startdate': startInclude,
            'enddate': endInclude
        }
 //convert any date field values to Date type (so filter function can find proper property name)
 this.originalItems.forEach(entry => {
    entry['sdate'] = new Date(entry['sdate']);
});

        //this.datefilteroriginalitems = this.originalItems;
       // console.log(this.datefilteroriginalitems)
    
        // this.audit = this.datefilteroriginalitems.filter(x => x.settlementDate >= startdate.toString() && x.settlementDate <= enddate.toString())
        // this.datefilteredaudit = this.datefilteroriginalitems.filter(x => x.settlementDate >= startdate.toString() && x.settlementDate <= enddate.toString())
       
        this.audit = this.filterService.filterFromMultiple(submit, this.datefilteroriginalitems);
        this.datefilteredaudit = this.filterService.filterFromMultiple(submit, this.datefilteroriginalitems);

        //console.log(this.audit);
        //console.log(this.datefilteredaudit);
        ////this.totalEntries = this.audit.length;

        this.loadingData = true;
        this.pagenlenth = false;
        this.originalItems=this.datefilteredaudit
        // this.orderBy(this.currentSortOrder, this.audit.length);
        this.setGrid(1, this.datefilteredaudit.length, "search");
       // this.orderBy(this.currentSortOrder);
//console.log(this.audit)
//console.log(this.datefilteredaudit,this.datefilteredaudit.length)

this.orderBy(this.defaultSortOrder);
this.paginationGrid();
//console.log(this.audit,this.audit.length);
// this.entryRangeSubscription = this.paginationService.entryRange
//   .subscribe(range => {
//     this.entryRange = range;
//     this.audit = this.datefilteredaudit;
//     this.exportItems = this.datefilteredaudit;
//     this.totalEntries = this.datefilteredaudit.length;
//   });
        // this.entryRangeSubscription = this.paginationService.entryRange
        //     .subscribe(range => {
        //         this.entryRange = range;
        //        // console.log("range" + this.entryRange[0], this.entryRange[1]);
        //         if (1 <= 0) {
        //             if (this.audit.length == 0) {
        //                 this.audit = this.originalItems;
        //                 //console.log('this.audit' + this.audit.length);
        //             }
        //             this.audit = this.originalItems.slice(this.entryRange[0], this.entryRange[1]);
        //             this.exportItems = this.originalItems;
        //             this.totalEntries = this.originalItems.length;
        //            console.log('this.audit' + this.audit.length);
        //         } else {
        //             this.audit = this.datefilteredaudit.slice(this.entryRange[0], this.entryRange[1]);
        //             this.exportItems = this.datefilteredaudit;
        //           console.log('this.audit' + this.audit.length);
        //             this.totalEntries = this.datefilteredaudit.length;
        //         }
        //     });
     
      


    }



    
 clearDateFilter() {
       
    this.fromInput.value = '';
    this.toInput.value = '';
    this.audit = this.originalItems;
    //console.log("clear date filter");
    this.totalEntries = this.audit.length;
     this.loadingData = true;
            this.pagenlenth = false;
            this.setGrid(1, this.audit.length, "search");
            this.orderBy(this.defaultSortOrder);
            this.paginationGrid();
            // this.entryRangeSubscription = this.paginationService.entryRange
            //     .subscribe(range => {
            //         this.entryRange = range;
            //         // console.log("range" + this.entryRange[0], this.entryRange[1]);
            //         if (!this.term.value) {
            //             console.log("111")
            //             // if (this.audit.length == 0) {
            //             //     this.audit = this.filteredBySettlementAccount;
            //             // }
            //             console.log( this.audit );
            //             this.audit = this.filteredBySettlementAccount.slice(this.entryRange[0], this.entryRange[1]);
            //             this.exportItems=this.filteredBySettlementAccount;
            //             this.totalEntries = this.filteredBySettlementAccount.length;
            //         } else {
            //             this.audit = this.searchFilteredItems.slice(this.entryRange[0], this.entryRange[1]);
            //             this.exportItems=this.searchFilteredItems;
            //             this.totalEntries = this.searchFilteredItems.length;
            //         }
            //     });
}
searchText() {
    this.result = this.TextSearch.controls['term'].value;
   //console.log(this.result);
   //console.log(this.originalItems);
    let itemsToSearch = this.originalItems;
    this.searchService.findItemsFromMultiple(this.result, itemsToSearch, this.searchArray)
      .then(allFiltered => {
        if (this.result.length > 0) {
      //console.log("Test");
          this.audit = allFiltered;
          this.searchFilteredItems = allFiltered;
        }
        else {
          //console.log("Test2")
          this.audit = this.originalItems;
          this.searchFilteredItems = this.originalItems;
        }
  
        //this.pagenlenth = false;
       // console.log(this.audit);
        //console.log(this.originalItems)
        this.setGrid(1, this.audit.length, "search");
        this.originalItems=this.searchFilteredItems;
         //this.orderBy(this.defaultSortOrder);
        //this.paginationGrid();
        this.entryRangeSubscription = this.paginationService.entryRange
          .subscribe(range => {
            this.entryRange = range;
            this.audit = this.searchFilteredItems.slice(this.entryRange[0], this.entryRange[1]);
            this.exportItems = this.originalItems;
            this.totalEntries = this.audit.length;
          });
      });
  }

// searchText() 
// {
//   this.result = this.TextSearch.controls['term'].value;
//   let itemsToSearch = this.originalItems;
//   this.searchService.findItemsFromMultiple(this.result, itemsToSearch, this.searchArray)
//     .then(allFiltered => {
//       console.log(allFiltered);
//       if (this.result.length > 0) {
//         this.audit = allFiltered;
//         this.searchFilteredItems = allFiltered;
//       } else {
//         this.audit = this.originalItems;
//       }
//       this.totalEntries = this.audit.length;
//       this.loadingData = true;
//       this.pagenlenth = false;
//       this.setGrid(1, this.audit.length, "search");
//       //this.paginationGrid();
//     });
// }
clearTextSearch() {
    this.term.setValue('');
    // this.audit = this.originalItems;
    // this.searchFilteredItems = [];
    // this.setGrid(1, this.audit.length);
    this.searchText();
}

  formatDataForSearch(data) 
  {
   // console.log(data);
    data.map(d => {
     // d.postingDate = this.datePipe.transform(d.postingDate, "dd/MM/yyyy");
      //d.settlementDate = this.datePipe.transform(d.settlementDate, "dd/MM/yyyy");});


      d.postingDate = this.datePipe.transform(d.postingDate.toString(), "MM/dd/yyyy");
      d.settlementDate = this.datePipe.transform(d.settlementDate, "MM/dd/yyyy");
    });


  }

}
